export enum GlobalMyAccountAuthmanagementRoutes {
  BASE = 'myaccount-authmanagement'
}
